import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-arch-dataflow',
	templateUrl:'./DataFlowPage.html',
	styles: [],
	styleUrls:['./DataFlowPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class DataFlowPage
{
	mdContent_23 = `\`\`\`mermaid
sequenceDiagram
  participant Browser
  participant Vertx as Vert.x Server
  participant Handler as Java Handler

  Browser->>Vertx: GET /dashboard
  Vertx->>Browser: index.html + dist/ (StaticHandler)

  Browser->>Vertx: POST /jwajax (AjaxCall JSON)
  Vertx->>Handler: deserialize
  Handler->>Handler: intercept chain
  Handler->>Handler: fireEvent()
  Handler->>Vertx: AjaxResponse
  Vertx->>Browser: DOM updates JSON

  Browser->>Vertx: WS /eventbus (STOMP subscribe)
  Vertx->>Handler: RabbitMQ exchange
  Vertx->>Browser: STOMP message

\`\`\``;
}
